const config = {
  userTypeAdmin: 'PortalCompras_CentralCompras',
  pathRootDocument: `${process.env.REACT_APP_BASE_PATH}/${process.env.REACT_APP_PROVIDER_DOCUMENT_PATH}`,
}

export default config;